import { isStoreBuild } from '@/lib/platform';

/**
 * Внешняя ссылка события календаря: Google Meet у живого урока, ссылка вебинара и т. п.
 *
 * ⚠️ В ПРИЛОЖЕНИИ — ЧЕРЕЗ `Browser.open`, А НЕ `<a target="_blank">` (02.10.2026, сборка 1.1.1). В WKWebView у
 * `target="_blank"` нет вкладки, куда открыться: нажатие либо молчит, либо уводит само приложение с нашего
 * экрана на чужой сайт без пути назад. Системное окно браузера открывается поверх и закрывается кнопкой — тем же
 * плагином открываются документы (`lib/legalLinks.ts`).
 *
 * На сайте — обычная новая вкладка.
 */

/** Адрес годится для открытия наружу: только http(s). Всё остальное кнопки не получает. */
export function externalHttpUrl(link: string | undefined | null): string | null {
  const s = (link ?? '').trim();
  if (!/^https?:\/\//i.test(s)) return null;
  try {
    const u = new URL(s);
    return u.protocol === 'http:' || u.protocol === 'https:' ? u.toString() : null;
  } catch {
    return null;
  }
}

export async function openExternal(link: string, app: boolean = isStoreBuild()): Promise<void> {
  const url = externalHttpUrl(link);
  if (!url) return;
  if (app) {
    try {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url });
      return;
    } catch {
      // Плагин не подгрузился — пробуем обычным путём: молчащая кнопка хуже.
    }
  }
  window.open(url, '_blank', 'noopener');
}

/**
 * Полный адрес страницы сайта для приложения: у приложения свой адрес (`capacitor://localhost`), и обычная
 * ссылка `/diagnostic/admin` вела бы в никуда (27.10.2026, сборка 1.1.2). Сайт выбирается по серверу сборки:
 * сборка стенда ходит в `api-staging` — значит, и страница со стенда, иначе — боевой сайт.
 */
export function siteUrl(path: string, apiBase: string = import.meta.env.VITE_API_BASE_PATH ?? ''): string {
  const site = /\/\/api-staging\./i.test(apiBase) ? 'https://staging.onebilim.kz' : 'https://academy.onebilim.kz';
  return `${site}${path.startsWith('/') ? path : `/${path}`}`;
}
